<!-- =========================================================================================
    File Name: CourseList.vue
    Description: Ag Grid table
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="vx-card p-8">
    <div class="flex flex-wrap items-center">
      <div class="flex-grow">
        <vs-dropdown class="cursor-pointer mr-2" vs-trigger-click>
          <div
            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span class="mr-2">
              {{ currentPage * paginationPageSize - (paginationPageSize - 1) }} -
              {{ simulationData.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : simulationData.length }}
              of {{ totalSimulations }}</span
            >
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>

          <vs-dropdown-menu>
            <vs-dropdown-item
              @click="
                gridApi.paginationSetPageSize(10);
                loadProductBuffer();
              "
            >
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item
              @click="
                gridApi.paginationSetPageSize(20);
                loadProductBuffer();
              "
            >
              <span>20</span>
            </vs-dropdown-item>
            <vs-dropdown-item
              @click="
                gridApi.paginationSetPageSize(50);
                loadProductBuffer();
              "
            >
              <span>50</span>
            </vs-dropdown-item>
            <vs-dropdown-item
              @click="
                gridApi.paginationSetPageSize(100);
                loadProductBuffer();
              "
            >
              <span>100</span>
            </vs-dropdown-item>
            <vs-dropdown-item
              @click="
                gridApi.paginationSetPageSize(150);
                loadProductBuffer();
              "
            >
              <span>150</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>

        <vs-button @click="addNewSimulation" class="ml-2 mr-2 round" color="primary" type="gradient">Create Simulation</vs-button>

        <vs-button
          @click="
            showArchived = !showArchived;
            loadProductBuffer();
          "
          class="ml-2 round"
          color="danger"
          type="gradient"
          >{{ showArchived === true ? 'Hide Archived' : 'Show Archived' }}</vs-button
        >
      </div>

      <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
      <vs-input
        @input="updateSearchQuery"
        class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
        placeholder="Search..."
        v-model="searchQuery"
      />
      <vs-button color="primary" icon-pack="feather" icon="icon-filter" class="ml-2" type="gradient" @click="filterPopup = !filterPopup"
        >Open Filter
      </vs-button>
      <!--- <vs-button @click="gridApi.exportDataAsCsv()" class="mb-4 md:mb-0">Export as CSV</vs-button> --->
    </div>

    <!-- AgGrid Table -->
    <ag-grid-vue
      :animateRows="true"
      :columnDefs="columnDefs"
      :components="components"
      :defaultColDef="defaultColDef"
      :enableRtl="$vs.rtl"
      :floatingFilter="true"
      :gridOptions="gridOptions"
      :pagination="true"
      :paginationPageSize="paginationPageSize"
      :rowData="simulationData"
      :suppressPaginationPanel="true"
      class="ag-theme-material w-100 my-4 ag-grid-table"
      colResizeDefault="shift"
      ref="agGridTable"
    >
    </ag-grid-vue>

    <vs-pagination :total="totalPages" v-model="currentPage" />

    <vs-popup :active.sync="filterPopup" title="Simulations Filter" id="SimulationFilterPopup">
      <vs-input
        v-model="searchQuery"
        @input="updateSearchQuery()"
        class="my-4 mt-5 w-full"
        size="large"
        :placeholder="`Simulation Search`"
      />
      <vx-card class="my-4" v-if="filterCourse">
        <div class="vx-row" v-if="filterSearchCoursesSelected">
          <div class="vx-col w-1/5 hidden md:flex items-center align-middle">
            <img
              :src="
                filterSearchCoursesSelected.thumbnail !== null
                  ? filterSearchCoursesSelected.thumbnail
                  : 'https://cdn.discordapp.com/attachments/746242308084858900/848762736255172679/default-placeholder.png'
              "
              class="responsive rounded"
              alt="Course Img"
            />
          </div>
          <div class="vx-col w-5/5 md:w-4/5 flex items-center align-middle">
            <div class="my-2">
              <h5 class="mb-2">{{ filterSearchCoursesSelected.name }}</h5>
              <div class="text-small text-danger cursor-pointer flex items-center" @click="filterCourseRemove()">
                <feather-icon icon="XIcon" svgClasses="h-5 w-5 mr-1" />Remove Filter
              </div>
            </div>
          </div>
        </div>
        <div class="flex justify-between items-center" v-else>
          <h2>No Course Filtered</h2>
          <vs-button
            color="primary"
            type="gradient"
            @click="
              filterPopup = false;
              filterSearchCoursesPopup = true;
            "
            icon-pack="feather"
            icon="icon-user-add"
            >Select Course
          </vs-button>
        </div>
      </vx-card>
      <vs-button color="primary" type="gradient" @click="filterPopup = false" class="mt-8">Close</vs-button>
    </vs-popup>
    <vs-popup :active.sync="filterSearchCoursesPopup" id="SearchCoursePopup" title="Search for Course by Name">
      <vs-table :data="filterSearchCoursesResults" :sst="true" max-items="5" id="SearchCourseTable" search @search="filterSearchCourses">
        <template slot="header">
          <h3 class="ml-4">Courses</h3>
        </template>

        <template slot="thead">
          <vs-th>ID</vs-th>
          <vs-th>Name</vs-th>
          <vs-th>Action</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr v-for="attach in data" :key="attach.id">
            <vs-td :data="attach.id">
              {{ attach.id }}
            </vs-td>

            <vs-td :data="`${attach.name}`">
              <div class="flex align-middle items-center">
                <img :src="attach.thumbnail" class="rounded mr-3" width="40px" />
                {{ `${attach.name}` }}
              </div>
            </vs-td>

            <vs-td>
              <vs-button
                color="primary"
                size="small"
                type="border"
                icon-pack="feather"
                icon="icon-filter"
                @click="filterCoursesSelected(attach)"
              >
                Filter
              </vs-button>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vs-popup>
  </div>
</template>

<script>
import TableName from './components/TableName.vue';
import TableSimulations from './components/TableSimulations.vue';
import TableActions from './components/TableActions.vue';
import TableID from './components/TableID';
import { AgGridVue } from 'ag-grid-vue';
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss';
import vSelect from 'vue-select';

export default {
  components: {
    AgGridVue,
    vSelect,
    TableName,
    TableSimulations,
    TableActions,
    TableID,
  },
  props: {
    courseId: {
      type: String,
      default: '',
      required: false,
    },
    filterCourse: {
      type: Boolean,
      default: true,
      required: false,
    },
  },
  data() {
    return {
      showArchived: false,

      simulationData: [],
      totalSimulations: 0,

      searchQuery: '',

      filterPopup: false,

      filterSearchCoursesPopup: false,
      filterSearchCoursesResults: [],
      filterSearchCoursesSelected: null,

      // AgGrid
      gridApi: null,
      gridOptions: {},
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
        valueFormatter: (params) => {
          if (typeof params.value === 'string') {
            const value = params.value;
            return value.charAt(0).toUpperCase() + value.slice(1);
          }

          return params;
        },
      },
      columnDefs: [
        {
          headerName: 'ID',
          field: 'id',
          filter: true,
          width: 250,
          cellRendererFramework: 'TableID',
        },
        {
          headerName: 'Name',
          field: 'name',
          filter: true,
          width: 400,
          cellRendererFramework: 'TableName',
        },
        {
          headerName: 'Status',
          field: 'status',
          filter: true,
        },
        {
          headerName: 'Difficulty',
          field: 'difficulty',
          filter: true,
        },
        {
          headerName: 'Actions',
          width: 150,
          sortable: false,
          cellRendererFramework: 'TableActions',
          cellRendererParams: {
            loadProductBuffer: this.loadProductBuffer.bind(this),
          },
        },
      ],

      // Cell Renderer Components
      components: {
        TableName,
        TableSimulations,
        TableActions,
        TableID,
      },
      totalPages: 0,
    };
  },
  watch: {},
  computed: {
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 10;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
        this.loadProductBuffer(val);
      },
    },
  },
  methods: {
    addNewSimulation() {
      this.$router.push('/a/simulation/create');
    },
    setColumnFilter(column, val) {
      const filter = this.gridApi.getFilterInstance(column);
      let modelObj = null;

      if (val !== 'all') {
        modelObj = { type: 'equals', filter: val };
      }

      filter.setModel(modelObj);
      this.gridApi.onFilterChanged();
    },
    updateSearchQuery() {
      this.currentPage = 0;
    },
    loadProductBuffer(page = 0) {
      if (page === 0) {
        page = this.currentPage;
      }

      this.$http
        .get(
          `simulation?amount=${this.paginationPageSize}&page=${page}&archived=${this.showArchived}&search=${this.searchQuery}&course=${this.courseId}`,
        )
        .then((response) => {
          if (response.data) {
            this.simulationData = response.data.rows;
            this.totalPages = response.data.totalPages;
            this.totalSimulations = response.data.total;
          }

          this.gridApi.sizeColumnsToFit();
        })
        .catch((exception) => {
          let error = 'An unknown error occurred while loading the courses course-classroom-list';
          if (exception.response) {
            error = exception.response.data.message;
          }

          return this.$vs.notify({
            title: 'Failed to load courses course-classroom-list',
            text: error,
            color: 'danger',
            position: 'top-right',
          });
        });
    },
    filterSearchCourses(term) {
      this.$http.get(`course?search=${term}&pageSize=5`).then((response) => {
        if (response.data) {
          this.filterSearchCoursesResults = response.data.data;
        }
      });
    },
    filterCoursesSelected(course) {
      this.filterSearchCoursesSelected = course;
      this.courseId = course.id;
      this.filterPopup = true;
      this.filterSearchCoursesPopup = false;
      this.loadProductBuffer();
    },
    filterCourseRemove() {
      this.courseId = '';
      this.filterSearchCoursesSelected = null;
      this.loadProductBuffer();
    },
  },
  mounted() {
    this.gridApi = this.gridOptions.api;

    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector('.ag-header-container');
      header.style.left = `-${String(Number(header.style.transform.slice(11, -3)) + 9)}px`;
    }
  },
  created() {
    this.loadProductBuffer();
    this.filterSearchCourses('');
  },
};
</script>

<style lang="scss">
.theme-dark {
  #SimulationFilterPopup {
    input.vs-inputx.vs-input--input {
      background: #02050d !important;
      border: 1px solid #222f44 !important;

      &:focus {
        border: 1px solid rgba(var(--vs-primary), 1) !important;
      }
    }
  }

  #SearchCoursePopup {
    .vs-popup--header {
      border-bottom: 1px solid #222f44 !important;
      border-bottom-left-radius: 0rem !important;
      border-bottom-right-radius: 0rem !important;
    }
  }

  #SearchCourseTable {
    border-radius: 0px !important;

    .vs-con-tbody {
      border-radius: 0px !important;
    }

    th {
      background: #030712 !important;
      border-top-left-radius: 0rem !important;
      border-top-right-radius: 0rem !important;
      border-top: 1px solid #222f44;
      border-bottom: 1px solid #222f44;
    }

    tr {
      transform: translate(0px) !important;

      &:hover {
        background-color: #02050d;
      }
    }
  }
}

.input-span-placeholder {
  color: #b4b7bd !important;
}
</style>
